import { lazy } from 'react';

const AvailableCircularityConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/available-circularity',
			component: lazy(() => import('./AvailableCircularityContainer'))
		}
	]
};

export default AvailableCircularityConfig;
